module.exports = __webpack_public_path__ + "img/d2374c6.png";